var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09188 19.3379L5.978 23.4961L1.90681 23.5822C0.690125 21.3255 0 18.7436 0 15.9999C0 13.3467 0.64525 10.8447 1.789 8.6416H1.78988L5.41437 9.3061L7.00212 12.9089C6.66981 13.8777 6.48869 14.9177 6.48869 15.9999C6.48881 17.1744 6.70156 18.2997 7.09188 19.3379Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7196 13.0107C31.9033 13.9786 31.9991 14.9782 31.9991 15.9997C31.9991 17.1452 31.8787 18.2626 31.6493 19.3404C30.8704 23.0081 28.8352 26.2107 26.0159 28.4771L26.015 28.4762L21.4498 28.2433L20.8036 24.2099C22.6744 23.1127 24.1364 21.3958 24.9065 19.3404H16.3509V13.0107H25.0313H31.7196Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0151 28.4763L26.016 28.4772C23.274 30.6811 19.7909 31.9998 15.9993 31.9998C9.9061 31.9998 4.60853 28.5941 1.9061 23.5823L7.09116 19.3379C8.44235 22.944 11.921 25.5111 15.9993 25.5111C17.7522 25.5111 19.3945 25.0372 20.8037 24.21L26.0151 28.4763Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2136 3.6835L21.0303 7.927C19.5719 7.01538 17.8479 6.48875 16.0009 6.48875C11.8303 6.48875 8.28657 9.17356 7.00307 12.909L1.79076 8.64175H1.78989C4.45276 3.50769 9.81714 0 16.0009 0C19.8831 0 23.4426 1.38287 26.2136 3.6835Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleActive);
export default __webpack_public_path__ + "static/media/google-active.7477bf19.svg";
export { ForwardRef as ReactComponent };